/* import { useEffect } from "react";
import React from "react";
import parse, { DOMNode, domToReact, Element } from "html-react-parser";
import { Chart } from "../contentFormats/Chart";
import { LinkTooltip } from "../contentFormats/LinkTooltip";

// Component map
const componentMap: Record<string, (props?: any) => React.ReactElement> = {
    linkTooltip: (props) => <LinkTooltip {...props} />,
    chart: (props) => <Chart {...props} />,
};

export function parseHtmlWithPlaceholders(html: string) {
    return parse(html, {
        replace: (domNode) => {
            // 1️⃣ A etiketleri tooltip
            if (domNode.type === "tag" && domNode.name === "a") {
                const el = domNode as Element;
                const href = el.attribs?.href || "";
                // hem linkDescription hem data-link-description desteği
                const linkDescription =
                    el.attribs?.linkdescription ||
                    el.attribs?.["data-link-description"] ||
                    "";

                const { style, ...restAttribs } = el.attribs;
                const children = domToReact(el.children as DOMNode[]);
                return (
                    <span className="a-with-tooltip" key={href}>
                        <a {...restAttribs}>{children}</a>
                        <i className="fi fi-rr-arrow-up-right-from-square"></i>
                        <LinkTooltip href={href} linkDescription={linkDescription} />
                    </span>
                );
            }

            // 3️⃣ CLASS="callout" elementleri
            if (domNode.type === "tag" && domNode.attribs?.class?.includes("callout")) {
                const el = domNode as Element;

                const classes = el.attribs.class.split(" ").filter(Boolean);
                const colorClass = classes.find(c =>
                    ["red", "green", "blue", "indigo", "orange"].includes(c)
                );

                const iconMap: Record<string, string> = {
                    indigo: "fi fi-sr-link",
                    orange: "fi fi-rr-lightbulb-on",
                    green: "fi fi-br-question",
                    blue: "fi fi-rr-info",
                    red: "fi fi-rr-diamond-exclamation",
                };
                const iconClass = colorClass ? iconMap[colorClass] : "";

                // style hariç diğer attribute'lar
                const { style, ...restAttribs } = el.attribs;

                // children'ı React elementlerine çevir
                const childrenArray = React.Children.toArray(
                    domToReact(el.children as DOMNode[])
                );

                // ilk strong elemanını bul
                const strongIndex = childrenArray.findIndex(
                    (child) =>
                        React.isValidElement(child) &&
                        (child as React.ReactElement).type === "strong"
                );

                let newChildren: React.ReactNode[] = [];

                if (strongIndex !== -1) {
                    const strongElement = childrenArray[strongIndex];

                    // header div oluştur ve içine ikonu + strong'u koy
                    const headerDiv = (
                        <div className="header" key="header">
                            {iconClass && <i className={iconClass} key="callout-icon" />}
                            {strongElement}
                        </div>
                    );

                    // eski strong'u children listesinden çıkar, header'ı en başa ekle
                    newChildren = [
                        headerDiv,
                        ...childrenArray.filter((_, i) => i !== strongIndex),
                    ];
                } else {
                    // strong yoksa ikon eklemeden çocukları aynen döndür
                    newChildren = childrenArray;
                }

                return React.createElement(
                    el.name,
                    { ...restAttribs, key: Math.random() },
                    newChildren
                );
            }

            // 2️⃣ PLACEHOLDER tag’leri
            if (domNode.type === "tag" && domNode.name.toLowerCase() === "placeholder") {
                const el = domNode as Element;
                const type = el.attribs?.type;
                const dataValues = el.attribs?.["data-values"];
                let props = {};
                if (dataValues) {
                    try {
                        props = JSON.parse(dataValues);
                    } catch {
                        console.warn("Invalid JSON in placeholder data-values");
                    }
                }

                if (type && componentMap[type]) {
                    return React.createElement(componentMap[type], { key: type + Math.random(), ...props });
                }

                return <span style={{ color: "red" }}>[Unknown placeholder: {type}]</span>;
            }
        },
    });
}
 */



import React from "react";
import parse, { DOMNode, domToReact, Element, HTMLReactParserOptions } from "html-react-parser";
import { Chart } from "../contentFormats/Chart";
import { LinkTooltip } from "../contentFormats/LinkTooltip";

// Component map (placeholder türleri)
const componentMap: Record<string, (props?: any) => React.ReactElement> = {
    linkTooltip: (props) => <LinkTooltip {...props} />,
    chart: (props) => <Chart {...props} />,
};

export function parseHtmlWithPlaceholders(html: string) {
    // ① replace fonksiyonunu bir değişkene ata
    const replaceFn = (domNode: DOMNode, index?: number): any => {
        // --- <a> etiketleri ---
        if (domNode.type === "tag" && domNode.name.toLowerCase() === "a") {
            const el = domNode as Element;
            const href = el.attribs?.href || "";
            const linkDescription =
                el.attribs?.linkdescription || el.attribs?.["data-link-description"] || "";

            const { style, ...restAttribs } = el.attribs;
            const children = domToReact(el.children as DOMNode[], { replace: replaceFn });

            return (
                <span className="a-with-tooltip" key={href || Math.random()}>
                    <a {...restAttribs}>{children}</a>
                    <i className="fi fi-rr-arrow-up-right-from-square"></i>
                    <LinkTooltip href={href} linkDescription={linkDescription} />
                </span>
            );
        }

        // --- callout class'lı elemanlar ---
        if (domNode.type === "tag" && domNode.attribs?.class?.includes("callout")) {
            const el = domNode as Element;
            const classes = el.attribs.class.split(" ").filter(Boolean);
            const colorClass = classes.find((c) =>
                ["red", "green", "blue", "indigo", "orange"].includes(c)
            );

            const iconMap: Record<string, string> = {
                indigo: "fi fi-sr-link",
                orange: "fi fi-rr-lightbulb-on",
                green: "fi fi-br-question",
                blue: "fi fi-rr-info",
                red: "fi fi-rr-diamond-exclamation",
            };
            const iconClass = colorClass ? iconMap[colorClass] : "";

            const { style, ...restAttribs } = el.attribs;

            const childrenArray = React.Children.toArray(
                domToReact(el.children as DOMNode[], { replace: replaceFn })
            );

            // İlk strong elementini bul ve header div ile sar
            const strongIndex = childrenArray.findIndex(
                (child) =>
                    React.isValidElement(child) &&
                    (child as React.ReactElement).type === "strong"
            );

            let newChildren: React.ReactNode[] = [];

            if (strongIndex !== -1) {
                const strongElement = childrenArray[strongIndex];
                const headerDiv = (
                    <div className="header" key="header">
                        {iconClass && <i className={iconClass} key="callout-icon" />}
                        {strongElement}
                    </div>
                );

                newChildren = [
                    headerDiv,
                    ...childrenArray.filter((_, i) => i !== strongIndex),
                ];
            } else {
                newChildren = childrenArray;
            }

            return React.createElement(el.name, { ...restAttribs, key: Math.random() }, newChildren);
        }

        // --- placeholder etiketleri ---
        if (domNode.type === "tag" && domNode.name.toLowerCase() === "placeholder") {
            const el = domNode as Element;
            const type = el.attribs?.type;
            const dataValues = el.attribs?.["data-values"];
            let props = {};

            if (dataValues) {
                try {
                    props = JSON.parse(dataValues);
                } catch {
                    console.warn("Invalid JSON in placeholder data-values");
                }
            }

            if (type && componentMap[type]) {
                return React.createElement(componentMap[type], { key: type + Math.random(), ...props });
            }

            return <span style={{ color: "red" }}>[Unknown placeholder: {type}]</span>;
        }
    };

    // ② parse fonksiyonuna replaceFn’i ver
    return parse(html, { replace: replaceFn });
}
